export default "__VITE_ASSET__CgTDirN7__"